import { render, staticRenderFns } from "./Seleccionarlibros.vue?vue&type=template&id=f0968378&scoped=true"
import script from "./Seleccionarlibros.vue?vue&type=script&lang=js"
export * from "./Seleccionarlibros.vue?vue&type=script&lang=js"
import style0 from "./Seleccionarlibros.vue?vue&type=style&index=0&id=f0968378&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0968378",
  null
  
)

export default component.exports